import { render } from "./InvoicesView.vue?vue&type=template&id=413f5d88&scoped=true"
import script from "./InvoicesView.vue?vue&type=script&lang=js"
export * from "./InvoicesView.vue?vue&type=script&lang=js"

import "./InvoicesView.vue?vue&type=style&index=0&id=413f5d88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-413f5d88"]])

export default __exports__